import React, { useEffect, useState } from "react";
import "./SubCategoriesOrders.css";
import Header from "../../../../Layout/Header/Header";
import CustomOrderCard from "../../../../CustomComponents/CustomOrderCard";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOrdersByRewardPointsAPI } from "../../../../../../Store/Action/rewardPointsAction";
import { toast } from "react-toastify";
import Icons from "../../../../../../Config/Images";
import CustomLoader from "../../../../CustomComponents/CustomLoader/CustomLoader";
import { getMyOrdersAPI } from "../../../../../../Store/Action/orderAction";

const SubCategoriesOrders = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [subCategoriesOrder, setSubcategoriesOrder] = useState([]);
  const [collapsedStates, setCollapsedStates] = useState({});
  const [myOrders, setMyOrders] = useState([]);

  const rewardPointUnitId = useSelector(
    (state) => state.rewardPoint.rewardPointUnitId
  );
  const handleExploreClick = () => {
    if (location.state.subCategoryId) {
      navigate(`/productsList/${location.state.subCategoryId}`, {
        state: { subCategoryName: location.state.header_name },
      });
    } else {
      toast.error("Something went wrong!");
    }
  };
  // useEffect(() => {
  //   const params = {
  //     sub_category_id: location.state.subCategoryId,
  //   };
  //   dispatch(
  //     getOrdersByRewardPointsAPI(params, (result) => {

  //     })
  //   );
  // }, [dispatch]);

  // const OrderDetailData = [
  //   {
  //     order_id: 1,
  //     order_status_id: 1,
  //     order_status: "delivered",
  //     original_order_status: "delivered",
  //     order_due_amount: 0,
  //     qty: 20,
  //     order_placed: "16 Jan",
  //     order_number: 11,
  //     brand_name: "Soni Jeweller",
  //     sub_total: 30000,
  //     invoice_preview_url: "https://example.com/invoice/11", // mock invoice

  //     // 👇 Mock products
  //     products: [
  //       {
  //         product_id: 101,
  //         name: "Golden Necklace (20K , 83.50)",
  //         netWeight: "330 gm",
  //         wastage: "0.500 gm",
  //         perPcsFine: "330 gm",
  //         qty: 12,
  //         image: "https://via.placeholder.com/80x80.png?text=Necklace", // mock image
  //       },
  //       {
  //         product_id: 102,
  //         name: "Diamond Ring (18K , 75.00)",
  //         netWeight: "50 gm",
  //         wastage: "0.200 gm",
  //         perPcsFine: "49.8 gm",
  //         qty: 2,
  //         image: "https://via.placeholder.com/80x80.png?text=Ring",
  //       },
  //       {
  //         product_id: 103,
  //         name: "Gold Bracelet (22K , 91.60)",
  //         netWeight: "150 gm",
  //         wastage: "0.300 gm",
  //         perPcsFine: "149.7 gm",
  //         qty: 5,
  //         image: "https://via.placeholder.com/80x80.png?text=Bracelet",
  //       },
  //     ],
  //   },
  // ];

  // toggle collapse state for each order by id

  const handleToggleCollapse = (orderId) => {
    setCollapsedStates((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  useEffect(() => {
    setLoading(true);
    // let params = {
    //   milestone_id: location.state.mileStoneId,
    //   reward_point_unit_id: rewardPointUnitId,
    // sub_category_id: location?.state?.subCategoryId,
    // };
    // if (location?.state?.mileStoneFlag) {
    //   params.sub_category_id = location?.state?.subCategoryId;
    // }
    // dispatch(
    //   getOrdersByRewardPointsAPI(params, (result) => {
    //     if (result?.status && Array.isArray(result.data)) {
    //       if (location.state.header_name === "Refer & Earn") {
    //         // ✅ Format as referrals
    //         const formattedReferrals = result.data.map((ref) => ({
    //           id: ref.user_id,
    //           name: ref.user_name || "Unknown User",
    //           mobile: ref.user_mobile_number,
    //         }));
    //         // setSubcategoriesOrder(formattedReferrals);
    //         // 👉 Append mock data for testing
    //         const mockData = [
    //           { id: 101, name: "Amit Sharma", mobile: "9876543210" },
    //           { id: 102, name: "Priya Singh", mobile: "9123456789" },
    //           { id: 103, name: "Rahul Verma", mobile: "9988776655" },
    //           { id: 104, name: "Sneha Kapoor", mobile: "9090909090" },
    //           { id: 105, name: "Ravi Kumar", mobile: "9871122334" },
    //           { id: 106, name: "Neha Mehta", mobile: "9812345678" },
    //           { id: 107, name: "Anil Yadav", mobile: "9955443322" },
    //           { id: 108, name: "Karan Patel", mobile: "9000011111" },
    //         ];

    //         // setSubcategoriesOrder([...formattedReferrals, ...mockData]);
    //         setSubcategoriesOrder(formattedReferrals);
    //       } else {
    //         // Transform API data → component-friendly format
    //         const formattedOrders = result.data.map((order) => ({
    //           order_id: order.order_id,
    //           order_status_id: order.order_status_id,
    //           order_status: order.order_status_name,
    //           original_order_status: order.order_status_name,
    //           order_due_amount: order.transaction_due_amount,
    //           qty: order.total_quantity,
    //           order_placed: order.order_date,
    //           order_number: order.order_number,
    //           brand_name: order.shop_name,
    //           sub_total: order.total_amount,
    //           invoice_preview_url: order.invoice_preview_url,
    //           courier_partner: order?.courier_partner,

    //           // 👇 format products array
    //           products: Array.isArray(order.order_items)
    //             ? order.order_items.map((item) => ({
    //                 product_id: item.product_id,
    //                 name: item.product_name,
    //                 netWeight: `${item.product_net_weight} gm`,
    //                 wastage: item.product_wastage_of_retailer,
    //                 perPcsFine: `${item.product_retailer_per_pcs_fine} gm`,
    //                 qty: item.product_quantity,
    //                 image:
    //                   item.product_images?.[0]?.product_image_url ||
    //                   "https://via.placeholder.com/80x80.png?text=Product",
    //               }))
    //             : [],
    //         }));

    //         setSubcategoriesOrder(formattedOrders);
    //       }
    //     }
    //     setLoading(false);
    //   })
    // );

    setLoading(true);
    let params = {
      milestone_id: location.state.mileStoneId,
      reward_point_unit_id: rewardPointUnitId,
      // sub_category_id: location?.state?.subCategoryId,
    };
    if (location?.state?.mileStoneFlag) {
      params.sub_category_id = location?.state?.subCategoryId;
    }
    dispatch(
      getMyOrdersAPI(params, (result) => {
        setSubcategoriesOrder(result?.data || []);
        setLoading(false);
      })
    );
  }, [dispatch, location.state.subCategoryId]);

  const handleCategoryRedirectClick = () => {};
  return (
    <>
      <Header />
      <div
        className="reward-points-main-div"
        style={{ backgroundColor: "#ffffff" }}
      >
        <div className="account-header">
          <p className="ac-header-para">
            {location?.state?.mileStoneFlag
              ? `${location.state.header_name} ${location.state.weight ?? ""} ${
                  location.state.unit ?? ""
                } `
              : `${location.state.header_name}`}
          </p>
          {location.state.header_name !== "Refer & Earn" ||
            (location.state.header_name !== "Per Pcs Product" && (
              <div>
                <button
                  className="header-btnn"
                  onClick={() => handleExploreClick()}
                >
                  Explore Now
                </button>
              </div>
            ))}
        </div>

        <div className="divider" />

        {loading ? (
          <div className="loaderContainer">
            <CustomLoader />
          </div>
        ) : location.state.header_name === "Refer & Earn" ? (
          <div className="refer-earn-div">
            {subCategoriesOrder.length > 0 ? (
              <>
                <h3 className="refer-title">Referrals</h3>
                <ul className="refer-list">
                  {subCategoriesOrder.map((ref) => (
                    <li key={ref.id} className="refer-item">
                      <div className="refer-info">
                        <span className="refer-name">{ref.name}</span> &nbsp;
                        <span className="refer-mobile">{ref.mobile}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <div className="EmptyCartDiv">
                <div className="text-content">
                  <h3>No Referrals Found</h3>
                  <p>Looks like you don’t have any referrals yet.</p>
                </div>
                <img src={Icons.emptyCartImage} alt="no referrals" />
                <div className="button-shopping">
                  <button onClick={() => navigate("/my-account/share")}>
                    Invite Friends
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : subCategoriesOrder.length > 0 ? (
          <div className="my-orders-content-div">
            {subCategoriesOrder.map((order, index) => (
              <CustomOrderCard
                key={index}
                order={order}
                isCollapsed={!!collapsedStates[order.order_id]}
                onToggleCollapse={() => handleToggleCollapse(order.order_id)}
                isTrackOrderVisible={
                  order?.original_order_status?.toLowerCase() !== "pending" &&
                  order?.original_order_status?.toLowerCase() !==
                    "send to the manufacturer"
                }
                invoice_preview_url={order?.invoice_preview_url}
                fromRewardPoint={true}
              />
            ))}
          </div>
        ) : (
          <div className="EmptyCartDiv">
            <div className="text-content">
              <h3>No Orders Found</h3>
              <p>
                Looks like you haven’t placed any orders in this category yet.
              </p>
            </div>
            <img src={Icons.emptyCartImage} alt="empty orders" />
            <div className="button-shopping">
              <button onClick={() => handleExploreClick()}>Explore now</button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SubCategoriesOrders;
